import FurnishingEditForm from "./furnishing-edit-form";

export default FurnishingEditForm;